import React from 'react';

import BusComponent from '../BusComponent';
import PointLayerEditor from './layerEditor/pointLayerEditor/PointLayerEditor';
import LayerHeader from './layerEditor/EditorHeader';
import Loader from '../Loader';
import {injectIntl} from "react-intl";

class UserDataLayerEditor extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isVisualizationSwitcherPopupOpen: false,
        };
        this.bindGluBusEvents({
            USER_DATA_LAYER_READY: this.onUserDataLayerReady,
            MAP_APPLY_USER_LAYERS_UPDATE: this.onLayerUpdated,
        });
    }

    componentDidMount() {
        const { userDataLayerId, mapInstance } = this.props;

        this.emit('GET_USER_DATA_LAYER_REQUEST', {
            userDataLayerId: userDataLayerId,
            mapInstanceId: mapInstance.id,
        });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onLayerUpdated({ userDataLayer }) {
        this.setState({ userDataLayer });
    }

    onUserDataLayerReady({ userDataLayer, userDataLayerMetadata }) {
        const { onUserDataLayerReady } = this.props;

        this.setState({ userDataLayer, userDataLayerMetadata });
        if (onUserDataLayerReady) {
            onUserDataLayerReady(userDataLayer);
        }
    }

    onFitClick = () => {
        const { mapInstance } = this.props;
        const { userDataLayer } = this.state;

        // We will fit the bounds to the first point for now
        const coordinates = userDataLayer.geoJSON.features[0].geometry.coordinates;
        // Define the buffer (in degrees) to add around the point
        var buffer = 0.01;
        // Calculate bounds that include the small buffer around the point
        const bounds = [
            [coordinates[0] - buffer, coordinates[1] - buffer], // Southwest coordinates
            [coordinates[0] + buffer, coordinates[1] + buffer], // Northeast coordinates
        ];

        this.emit('MAP_FIT_BOUNDS_REQUEST', {
            bounds,
            offset: [0, 0],
            mapInstanceId: mapInstance.id,
        });
    };

    onDeleteClick = () => {
        const { onDone, userDataLayerId, mapInstance } = this.props;

        const userLayer = mapInstance.userDataLayers.find(layer => layer.id === userDataLayerId);

        this.emit('USER_LAYER_DELETE_REQUEST', {
            userData: userLayer,
            userLayerTitle: userLayer.title,
        });
        onDone();
    };

    onSaveTitleClick = title => {
        const { userDataLayerId, mapInstance } = this.props;

        this.emit('UPDATE_USER_LAYER_TITLE', {
            title,
            layerId: userDataLayerId,
            mapInstanceId: mapInstance.id,
        });
    };

    render() {
        const { intl, onDone, mapInstance } = this.props;
        const { userDataLayer, userDataLayerMetadata } = this.state;

        if (!userDataLayer) {
            return (
                <div className="user-data-upload-editor">
                    <div className="user-data-upload-editor__loader">
                        <Loader text={intl.formatMessage({ id: 'dataBrowser.loadingLayerData' })} />
                    </div>
                </div>
            );
        }
        return (
            <div className="user-data-upload-editor">
                <LayerHeader
                    userDataLayerTitle={userDataLayer.title}
                    onFitClick={this.onFitClick}
                    onDoneClick={onDone}
                    onSaveTitleClick={this.onSaveTitleClick}
                    onDeleteClick={this.onDeleteClick}
                />
                <PointLayerEditor
                    mapInstanceId={mapInstance.id}
                    userDataLayer={userDataLayer}
                    userDataLayerMetadata={userDataLayerMetadata}
                />
            </div>
        );
    }
}

export default injectIntl(UserDataLayerEditor);
